<header class="top-header">
  <div class="container-fluid">
    <nav class="navbar p-0">
      <div class="site-logo d-flex align-items-center">
        <a href="javascript:;" onclick="toggleSideMenu()" class="menu-toggle mr-3 d-lg-none"
          ><i class="far fa-bars"></i
        ></a>
        <a routerLink="/jobs" routerLinkActive="active" onclick="reloadMenu()"
          ><img src="{{ egan_hub_site_logo }}" alt="Andyegan" id="appSiteLogo"
        /></a>
        <div *ngIf="countShouldBeVisible" class="total-count">
          <div class="total-count-text">Total {{ totalCountLabel }}: {{ totalCount }}</div>
        </div>
      </div>
      <div class="right-navbar">
        <ul class="nav navbar-nav justify-content-end flex-row">
          <li class="nav-item">Hello, {{ fullName }}!</li>
          <!-- <li class="nav-item notification dropdown">
                        <a href="javascript:void(0);" class="dropdown-toggle" data-toggle="dropdown"><i
                                class="fas fa-bell"></i> <span class="">2</span></a>
                        <div class="dropdown-menu dropdown-card dropdown-left p-0">
                            <div class="card">
                                <div class="card-header mb-0"><span>Notifications</span></div>
                                <ul class="card-body list-unstyled dropdown-list-group">
                                    <li><a href="#"><span>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                                                do eiusmod</span></a></li>
                                    <li><a href="#"><span>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                                                do eiusmod</span></a></li>
                                    <li><a href="#"><span>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                                                do eiusmod</span></a></li>
                                </ul>
                                <div class="card-footer text-center">
                                    <a href="javascript:void(0);" class="text-uppercase">See all Notifications</a>
                                </div>
                            </div>
                        </div>
                    </li> -->
          <li class="nav-item">
            <a href="javascript:;" (click)="logout()"><i class="fas fa-door-open"></i> Log out</a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</header>
